var Curriculog = Curriculog || {};

Curriculog.DropdownView = (function ($, _, Backbone, DropdownView) {

	DropdownView = Curriculog.CurriculogView.extend({
		tagName: 'select',

		initialize: function (options) {
			this.subviews = [];
			this.className = options.id;
			this.attributes = options.attributes || [];
			this.collection = options.collection || [];
			this.disabledList = options.disabledList || [];
			this.noAvailableOptionsMessage = options.noAvailableOptionsMessage || 'No Options Available';
			this.firstOption = options.firstOption || '';
			this.selectedValue = options.selectedValue || '';
			this.container = document.createDocumentFragment();
			this.render();
		},

		render: function () {
			if (this.collection.length && this.disabledList.length <= this.collection.length) {
				var that = this;

                // Set the disabled property to false on the select element if it was set
                // by renderEmptyList
                this.$el.prop('disabled', false);

				this.collection.sort();

				if (this.firstOption) {
					this.createFirstOption();
				}

				_.each(this.collection.models, function (model) {
					var id  = model.get('id'),
					    options = {value: id, selectedValue: that.selectedValue};

					options.disabled = that.isDisabled(id, that.disabledList);

					that.createNewOption(model, options);
				});
			} else {
				this.renderEmptyList();
			}

			// Finally, append the document fragment to the select element so that
			// only one DOM reflow occurs
			// (http://ozkatz.github.io/avoiding-common-backbonejs-pitfalls.html -> Section 2)
			this.$el.append(this.container);
		},

		isDisabled: function (itemID, disabledList) {
			return _.contains(disabledList, itemID) ? true : false;
		},

		eachDropdownItem: function (fn) {
			for (var i = 0; i < this.subviews.length; i++) {
				fn(this.subviews[i]);
			}
		},

		getCurrentSelection: function () {
			return $(this.el).find('option:selected').val();
		},

		changeCurrentSelection: function (value) {
			$(this.el).find('[value="' + value + '"]').prop('selected', true);
		},

		createFirstOption: function (options) {
			var model = {},
			    defaults = {
				    name: this.firstOption,
				    disabled: false,
			    };

			// Add any options missing from the default object and then update any
			// options from the options object
			options = options ? _.extend(_.defaults(defaults, options), options) : defaults;

			model = new Curriculog.CurriculogModel(options);

			this.createNewOption(model, {selectedValue: this.selectedValue});
		},

		createNewOption: function (model, options) {
			var subView = {},
				defaults = {
					item: model,
				};

			// Add any options missing from the default object and then update any
			// options from the options object
			options = options ? _.extend(_.defaults(defaults, options), options) : defaults;

			subView = new Curriculog.DropdownItemView(options);

			// Add the element to the document fragment to be able to
			// render to the DOM later on
			this.container.appendChild(subView.el);
			this.subviews.push(subView);
		},

		renderEmptyList: function () {
			this.createFirstOption({
				'disabled': true,
				'selected': true,
				'name': this.noAvailableOptionsMessage
			});

			this.$el.prop('disabled', true);
		},
	});
	return DropdownView;

})($, _, Backbone, Curriculog.DropdownView || {});
